import { ID_MULTILANGUGAE } from '../../Settings/Constants/Constants';

const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];

export const MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];

const MONTHS_ENG = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const getMonth = (datetime = Date.now()) => {
  const date = new Date(datetime);
  return MONTHS[date.getMonth()];
};

const getDay = (datetime) => {
  const date = new Date(datetime);
  return DAYS[date.getDay()];
};

const getDayMultilanguage = (datetime, parameters) => {
  return parameters?.[getDay(datetime)]?.value;
};

const getHoursAndMinutes = (datetime) => {
  const date = new Date(datetime);
  return `${date.getUTCHours()}:${date.getUTCMinutes()}`;
};

const getHoursAndMinutes12Hours = (datetime) => {
  const date = new Date(datetime);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const isAm = hours < 12;
  const hours12 = hours % 12 || 12;
  const hoursFormat = (hours12 < 10 ? '0' : '')?.concat(hours12);
  const minutesFormat = (minutes < 10 ? '0' : '')?.concat(minutes);
  const format = `${hoursFormat}:${minutesFormat} ${isAm ? 'a.m.' : 'p.m.'}`;
  return format;
};

const getFormatedDate = (datetime = false, other = false) => {
  const date = datetime ? new Date(datetime) : new Date();
  const day = date.getDate();
  const month = MONTHS[date.getMonth()];
  const monthNumber = date.getMonth() + 1;
  const year = date.getFullYear();
  const format = `${month} ${day}, ${year}`;
  const formatDate = `${year}-${monthNumber}-${day}`;
  if (other) return formatDate;
  return format;
};

const getFormattedDateMultilanguage = (datetime = false, withHours = false, multilanguage = 2) => {
  const MONTHS_LANGUAGE = multilanguage === ID_MULTILANGUGAE.ESP ? MONTHS : MONTHS_ENG;
  const date = datetime ? new Date(datetime) : new Date();
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // hours and minutes format 00 when x < 10
  const hoursStr = (hours < 10 ? '0' : '')?.concat(hours?.toString());
  const minutesStr = (minutes < 10 ? '0' : '')?.concat(minutes?.toString());

  const format = `${MONTHS_LANGUAGE?.[month]} ${day}, ${year} ${
    withHours ? `${hoursStr}:${minutesStr} h` : ''
  }`;
  return format;
};

// * format = month-day-year
const getformatedDateNoLetters = (datetime = false, option = false) => {
  const date = datetime ? new Date(datetime) : new Date();
  const defaultDay = date.getDate();
  const defaultMonth = date.getMonth() + 1;
  const defaultYear = date.getFullYear();

  const monthStr = (defaultMonth < 10 ? '0' : '')?.concat(defaultMonth);
  const dayStr = (defaultDay < 10 ? '0' : '')?.concat(defaultDay);
  if (option) return `${defaultYear}-${monthStr}-${dayStr}`;
  return `${monthStr}-${dayStr}-${defaultYear}`;
};

function getClosestDate(dates) {
  const today = new Date();
  const futureDates = dates.filter((date) => new Date(date) >= today);
  if (futureDates.length === 0) return null;
  let closestDate = futureDates[0];
  let minDifference = Math.abs(new Date(closestDate) - today);

  for (let i = 1; i < futureDates.length; i++) {
    const currentDifference = Math.abs(new Date(futureDates[i]) - today);
    if (currentDifference < minDifference) {
      minDifference = currentDifference;
      closestDate = futureDates[i];
    }
  }

  return closestDate;
}

export {
  getFormatedDate,
  getHoursAndMinutes,
  getMonth,
  getFormattedDateMultilanguage,
  getHoursAndMinutes12Hours,
  getDay,
  getDayMultilanguage,
  getformatedDateNoLetters,
  getClosestDate
};
